import VueRecaptcha from 'vue-recaptcha';

import AppTeamMembersContainer from './AppTeamMembersContainer';
import AppPreFooterNewsletter from './AppPreFooterNewsletter';
import AppPopupNewsletter from './AppPopupNewsletter';
import AppBeforeAfterSlider from './AppBeforeAfterSlider';
import AppFooterNewsletter from './AppFooterNewsletter';
import AppContactFormFullCircle from './AppContactFormFullCircle';
import AppImageSlider from './AppImageSlider';
import AppFeatureSlider from './AppFeatureSlider';
import AppImageSliderAlt from './AppImageSliderAlt';
import AppIconSlider from './AppIconSlider';
import AppScrollerSlider from './AppScrollerSlider';
import AppTextSlider from './AppTextSlider';
import AppNavigation from './AppNavigation';
import AppTeamMember from './AppTeamMember';
import AppAccordion from './AppAccordion';
import AppModal from './AppModal.vue';
import AppSelect from './AppSelect';
import AppMap from './AppMap';
import AppStickyNav from './AppStickyNav';
import FormModal from './FormModal';

const Swiper = () => import('vue-awesome-swiper/src/swiper.vue');
const SwiperSlide = () => import('vue-awesome-swiper/src/slide.vue');

export const components = {
    AppTeamMembersContainer,
    AppPreFooterNewsletter,
    AppPopupNewsletter,
    AppBeforeAfterSlider,
    AppFooterNewsletter,
    AppContactFormFullCircle,
    AppFeatureSlider,
    AppImageSlider,
    AppImageSliderAlt,
    AppIconSlider,
    AppScrollerSlider,
    AppTextSlider,
    AppNavigation,
    AppTeamMember,
    VueRecaptcha,
    AppAccordion,
    SwiperSlide,
    AppSelect,
    AppModal,
    AppMap,
    Swiper,
    AppStickyNav,
    FormModal,

};

export default components;
